import React from "react";
import { CheckCircle2Icon, XCircleIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { afterItems, beforeItems } from "../../data/landing";
export function TransformationSection() {
  return <Section tone="sand" cta="I want to make this change" data-id="element-295" data-mp="3hzx2xfpvweor">
      <SectionHeading eyebrow="The transformation" title={<>
            From looking at cases… <em className="text-rose" data-id="element-297" data-mp="einab6tpip2p">to learning from them</em>
          </>} data-id="element-296" data-mp="3mwvxfzdgmnnh" />

      <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-298" data-mp="jgylbkvqn5mi">
        <div className="rounded-3xl border border-red-200 bg-white p-6 md:p-8" data-id="element-299" data-mp="jecdrl8ukq4a">
          <h3 className="flex items-center gap-2 font-serif text-2xl font-bold text-red-700" data-id="element-300" data-mp="5gntaeiozkzr">
            <XCircleIcon className="h-7 w-7" aria-hidden="true" data-id="element-301" data-mp="9gpivpb5knyo" />
            Before
          </h3>
          <ul className="mt-5 space-y-3.5" data-id="element-302" data-mp="2q5v06xndf44p">
            {beforeItems.map(i => <li key={i} className="flex gap-3 text-[16px] leading-snug text-inkSoft" data-id="element-303" data-mp="2u9j7rgc05zpy">
                <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-304" data-mp="2h6g15eazwe7d" />
                {i}
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl bg-ink p-6 text-white shadow-xl md:p-8" data-id="element-305" data-mp="2q6kzz024i49x">
          <h3 className="flex items-center gap-2 font-serif text-2xl font-bold text-green-400" data-id="element-306" data-mp="2m4hm64rzenlh">
            <CheckCircle2Icon className="h-7 w-7" aria-hidden="true" data-id="element-307" data-mp="304960m56iy7e" />
            After
          </h3>
          <ul className="mt-5 space-y-3.5" data-id="element-308" data-mp="2v55ymv1q8fw9">
            {afterItems.map(i => <li key={i} className="flex gap-3 text-[16px] font-medium leading-snug text-white" data-id="element-309" data-mp="2v3bo8ao3066f">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-green-400" aria-hidden="true" data-id="element-310" data-mp="39vvdq8ib6f5e" />
                {i}
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mx-auto mt-10 max-w-2xl text-center text-[17px] leading-relaxed text-inkSoft md:text-lg" data-id="element-311" data-mp="3ise3xcz5noya">
        I didn't create this system to give you more information.{" "}
        <strong className="text-ink" data-id="element-312" data-mp="2bk2ldrp81pd6">
          I created it to help you get more value from the information you already have.
        </strong>
      </p>
    </Section>;
}